import { CustomCheckboxInput, QuestionCard } from '@my/ui'
import { Control, useWatch } from 'react-hook-form'

import { InputField } from '../helpers/Helper'
import images from '../../../assets/images'
import { confirmationOptions } from '../data'

interface CreditProps {
  control: Control<any>
}

export const Credit: React.FC<CreditProps> = ({ control }) => {
  const hasCreditScoreGoals = useWatch({ name: "Credit - Has Credit Score Goals"});
  const hasPastIssuesGettingCredit = useWatch({ name: "Credit - Has Past Issues Obtaining Credit"});
  const hasCreditHistoryChallenges = useWatch({ name: "Credit - Has Credit History Challenges"});
  return (
    <>
      <QuestionCard questionGroupTitle="What is your current credit score?">
        <InputField
          control={control}
          name="Credit - Score"
          placeholder="Current Credit Score"
          label=""
          //icon={images.retirementAge}
        />
      </QuestionCard>
      <QuestionCard questionGroupTitle="Have you checked your credit report recently for any inaccuracies or fraudulent activities?">
        <CustomCheckboxInput
          options={confirmationOptions}
          control={control}
          name="Credit - Recent check for fraud activity"
          circle
        />
      </QuestionCard>
      <QuestionCard questionGroupTitle="Are there any specific goals you have regarding your credit score?">
        <CustomCheckboxInput
          options={confirmationOptions}
          control={control}
          name="Credit - Has Credit Score Goals"
          circle
        />

        {hasCreditScoreGoals && <InputField
          control={control}
          name="Credit - Credit Score Goals"
          placeholder="If so, please describe."
          height={90}
          multiline
        />}
      </QuestionCard>
      <QuestionCard questionGroupTitle="Have you faced any issues with obtaining credit in the past?">
        <CustomCheckboxInput
          options={confirmationOptions}
          control={control}
          name="Credit - Has Past Issues Obtaining Credit"
          circle
        />

        {hasPastIssuesGettingCredit && <InputField
          control={control}
          name="Credit - Past Issues Obtaining Credit"
          placeholder="If so, please describe."
          height={90}
          multiline
        />}
      </QuestionCard>
      <QuestionCard questionGroupTitle="Have you faced any challenges due to your credit history?">
        <CustomCheckboxInput
          options={confirmationOptions}
          control={control}
          name="Credit - Has Credit History Challenges"
          circle
        />

        {hasCreditHistoryChallenges && <InputField
          control={control}
          name="Credit - Credit History Challenges"
          placeholder="If so, please describe."
          height={90}
          multiline
        />}
      </QuestionCard>
    </>
  )
}
